<template>
	<el-form>
		<div class="caption">绑定手机号</div>
		<el-form-item>
			<el-input
				v-model="post.mobile"
				prefix-icon="el-icon-user"
				placeholder="请填写手机号"
				@keyup.enter.native="resetPassword"
			></el-input>
		</el-form-item>
		<el-form-item>
			<el-input
				v-model="post.smscode"
				prefix-icon="el-icon-chat-dot-square"
				placeholder="短信验证吗"
				@keyup.enter.native="resetPassword"
			></el-input>
			<span class="btn-send-sms">
				<Sms :mobile="post.mobile"></Sms>
			</span>
		</el-form-item>
		<el-form-item>
			<el-input
				v-model="post.password"
				prefix-icon="el-icon-lock"
				placeholder="设置登录密码"
				show-password
				@keyup.enter.native="resetPassword"
			></el-input>
		</el-form-item>
		<el-form-item class="el-form-action">
			<el-button type="primary" @click.prevent="resetPassword" :loading="loading">绑定账号</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
import Sms from "@/components/Sms";

export default {
	name: "UserBind",
	components: { Sms },
	data() {
		return {
			loading: false,
			post: {
				mobile: "",
				password: "",
				smscode: ""
			}
		};
	},
	methods: {
		resetPassword() {
			this.$message.closeAll();

			var patrn = /^(1|01)\d{10}$/;
			if (!this.post.mobile) {
				return this.$message.error("请填写手机号码");
			}
			if (!patrn.test(this.post.mobile) && this.post.mobile != "") {
				return this.$message.error("请正确填写手机号码");
			}
			if (!this.post.smscode) {
				return this.$message.error("请填写短信验证码");
			}
			if (!this.post.password) {
				return this.$message.error("请填写登录密码");
			}

			this.loading = true;
			this.axios
				.post(this.axios.apiGateway + "user/resetPassword", this.post)
				.then(res => {
					if (res.data.errcode) {
						this.$message.error(res.data.errmsg);
					} else {
						this.$notify({
							type: "success",
							title: "密码重置成功",
							message: "请使用新密码重新登录"
						});
						this.$store.dispatch("logout");

						this.$parent.hide && this.$parent.hide();
					}
				});
		}
	}
};
</script>

<style lang="less" scoped>
.btn-send-sms {
	position: absolute;
	top: 1px;
	right: 15px;
	a {
		color: #999;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Passport/UserBind.vue